import { Editor, TLCursorType, useEditor, useValue } from "tldraw"
import { LDInstanceMeta } from "../shared/LDInstance"
import { useEffect, useRef } from "react"

export type CursorType = TLCursorType | "circle"

export function CustomCursor() {
  const editor = useEditor()
  const tool = editor.getCurrentTool().id
  const isVisible = tool === "marker" || tool === "eraser2"

  const instanceMeta = useValue(
    "instance meta",
    () => editor.getInstanceState().meta as LDInstanceMeta,
    [editor],
  ) as LDInstanceMeta

  const radius =
    tool === "eraser2" ? instanceMeta.eraserRadius : instanceMeta.markerRadius

  const scale = tool === "marker" ? 1.6 : 2.3
  const zoomedRadius = radius * scale

  const cursorRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isVisible || !cursorRef.current) return

    let ticking = false

    const handlePointerMove = (e: PointerEvent) => {
      const screenPoint = { x: e.clientX, y: e.clientY }

      if (!ticking) {
        requestAnimationFrame(() => {
          if (cursorRef.current) {
            const viewportPoint = editor.screenToPage(screenPoint)
            cursorRef.current.style.left = `${viewportPoint.x}px`
            cursorRef.current.style.top = `${viewportPoint.y}px`
          }
          ticking = false
        })
        ticking = true
      }
    }

    window.addEventListener("pointermove", handlePointerMove)
    return () => {
      window.removeEventListener("pointermove", handlePointerMove)
    }
  }, [editor, isVisible])

  if (!isVisible) return null

  return (
    <div
      ref={cursorRef}
      style={{
        position: "absolute",
        top: "0px",
        left: "0px",
        width: `${zoomedRadius * 2}px`,
        height: `${zoomedRadius * 2}px`,
        borderRadius: "50%",
        border: `1px solid ${tool === "eraser2" ? "red" : "black"}`,
        background: "transparent",
        transform: "translate(-50%, -50%)",
        pointerEvents: "none",
        zIndex: 9999,
      }}
    />
  )
}

// export function getDomCursor(container: HTMLElement): HTMLDivElement {
//   if (!domCursor) {
//     domCursor = document.createElement("div")
//     domCursor.id = "custom-circle-cursor"
//     Object.assign(domCursor.style, {
//       position: "absolute", // changed from fixed
//       top: "0px",
//       left: "0px",
//       width: "0px",
//       height: "0px",
//       borderRadius: "50%",
//       border: "1px solid black",
//       pointerEvents: "none",
//       zIndex: "2",
//       transform: "translate(-50%, -50%)",
//       willChange: "transform",
//       display: "none",
//     })
//     container.appendChild(domCursor) // append to specific container
//   }
//   return domCursor
// }

export function setCursor(editor: Editor, type: CursorType, tool: string = "") {
  if (type === "circle") {
    editor.updateInstanceState({
      cursor: { type: "none", rotation: 0 }, // still needed for TLDraw state logic
    })
  } else {
    clearDomCursor(editor)
    editor.updateInstanceState({
      cursor: {
        type:
          type === "select" ? "default" : type === "hand" ? "grab" : "cross",
        rotation: 0,
      },
    })
  }
}

export function clearDomCursor(editor: Editor) {
  // reset the tool to select

  editor.updateInstanceState({
    cursor: { type: "none", rotation: 0 },
  })
  editor.setCursor({ type: "none", rotation: 0 })

  // if (domCursor) {
  //   domCursor.style.display = "none"
  //   domCursor.remove() // ← actually remove from DOM
  //   domCursor = null
  // }
}
